// extracted by mini-css-extract-plugin
module.exports = {"inputField":"style_inputField__1pjsY","label":"style_label__28m8V","icon":"style_icon__2t1Q0","withIcon":"style_withIcon__24ZEW","simpleInput":"style_simpleInput__3eKh0"};